import { render, staticRenderFns } from "./IconOpenLg.vue?vue&type=template&id=5789bdab&"
import script from "./IconOpenLg.vue?vue&type=script&lang=js&"
export * from "./IconOpenLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5789bdab')) {
      api.createRecord('5789bdab', component.options)
    } else {
      api.reload('5789bdab', component.options)
    }
    module.hot.accept("./IconOpenLg.vue?vue&type=template&id=5789bdab&", function () {
      api.rerender('5789bdab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconOpenLg.vue"
export default component.exports